import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { practiceAreas } from '../data/siteData';
import './Services.css';

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="section-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">OUR PRACTICE AREAS</span>
          <h2 className="section-title">
            Comprehensive Legal
            <br />
            <span className="title-accent">Excellence</span>
          </h2>
          <p className="section-description">
            Delivering world-class legal services across all major practice areas,
            combining deep expertise with innovative approaches to complex challenges.
          </p>
        </motion.div>

        <div className="services-grid">
          {practiceAreas.map((service, index) => (
            <motion.div
              key={service.title}
              className="service-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.summary}</p>
              <div className="service-specialties">
                {service.specialties.map((specialty) => (
                  <span key={specialty} className="specialty-tag">
                    {specialty}
                  </span>
                ))}
              </div>
              <Link to={`/services/${service.slug}`} className="service-link">
                Learn More
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" />
                </svg>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
